
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SubTaskDetails, SuperTask } from 'app-models';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromTask from "../../task-state/reducers/task.reducer";
import * as Task from "./../../../superTask/task-state/actions/task.actions";
import { LookupService } from 'src/app/services/lookup-data.service';

@Component({
  selector: 'app-document-checklist',
  templateUrl: './document-checklist.component.html',
  styleUrls: ['./document-checklist.component.scss']
})
export class DocumentChecklistComponent implements OnInit {

  primaryData: any;  
  superTask: SuperTask;
  subTaskDetails: SubTaskDetails;
  task: SubTaskDetails;
  taskTypeCode: string;
  isSimplifyData: boolean;
  paramTaskTypeCode: string;
  superTaskTypeCode: string;
  caseId: number;
  observableSubscription$ = new Subject();
  subTaskLoaded$ = new Subject();
  isBeneficiaryInitiate;

  constructor(
    private lookupService: LookupService,
    private store: Store<fromTask.State>
  ) { }

  ngOnInit(): void {
    this.lookupService.isBeneficiaryInitiate.pipe(takeUntil(this.observableSubscription$)).subscribe(val => {;this.isBeneficiaryInitiate = val})
    combineLatest([
      this.store.select(fromTask.getSubTaskList),
      this.store.select(fromTask.getSuperTask)
    ])
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(([subTaskList, superTask]) => {
        if(subTaskList && superTask){
          this.superTask = superTask;
          this.taskTypeCode = subTaskList[0].taskTypeCode;          
          this.postNgOnInit();
        }
      });    
  }

  postNgOnInit(){      
    this.lookupService
      .taskData
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data: SubTaskDetails) => {
        if (data?.id && this.taskTypeCode) {          
          this.task = data;
          this.subTaskDetails = data;   
          sessionStorage.setItem("taskTypeId",JSON.parse(JSON.stringify(this.subTaskDetails.taskTypeId)));                    
          this.store.dispatch(new Task.SetActiveSubTaskIndex(this.subTaskDetails?.id));
          let familyId;
          if(["K1","K3"].includes(this.subTaskDetails.taskTypeDetails.visaType)&&this.subTaskDetails.jsonInput) {
            const jsonInput = JSON.parse(this.subTaskDetails.jsonInput);
            familyId = jsonInput && jsonInput.primaryApplicant && jsonInput.primaryApplicant?.id? jsonInput.primaryApplicant?.id : null;
          } else {
            familyId = this.subTaskDetails.familyId ? this.subTaskDetails.familyId : null;
          }
          this.primaryData = {
            superTaskId: this.subTaskDetails.superTaskId,
            subTaskId: this.subTaskDetails?.id,
            caseType: this.taskTypeCode,
            caseId: this.caseId || this.subTaskDetails.petitionId,
            petitionId: this.subTaskDetails.petitionId,
            foreignCompanyId: this.subTaskDetails.foreignCompanyId,
            visatype:
              this.paramTaskTypeCode === "I130"
                ? "GC"
                : this.subTaskDetails.taskTypeDetails.visaType
                  ? this.subTaskDetails.taskTypeDetails.visaType
                  : this.subTaskDetails.taskTypeDetails.immCategoryCode,
            visaName: this.subTaskDetails.taskTypeDetails.visaName,
            petitionType: this.subTaskDetails.taskTypeDetails.petitionType,
            immSpecialistId: this.subTaskDetails.immSpecialistId,
            attorneyId: this.subTaskDetails.attorneyId,
            sponsorId: ["K1", "K3"].includes(
              this.subTaskDetails.taskTypeDetails.visaType
            )
              ? this.subTaskDetails.beneficiaryId
              : this.subTaskDetails.sponsorId
                ? this.subTaskDetails.sponsorId
                : null,
            familyId,
            immigrationCategory:
              this.paramTaskTypeCode === "I130"
                ? "GC"
                : this.superTask && this.superTask.immigrationCategory
                  ? this.superTask.immigrationCategory.code
                  : null,
            immigrationCategoryName:
              this.superTask && this.superTask.immigrationCategory
                ? this.superTask.immigrationCategory.name
                : null,
            immigrationClassification:
              this.superTask && this.superTask.immigrationClassification
                ? this.superTask.immigrationClassification.code
                : null,
            isBeneficiaryInitiate: this.isBeneficiaryInitiate,
            immigrationClassificationName:
              this.superTask && this.superTask.immigrationClassification
                ? this.superTask.immigrationClassification.name
                : null,
            superTaskTypeCode: this.superTaskTypeCode,            
            getTaskType:
              this.superTaskTypeCode === "NONIMMPET"
                ? this.subTaskDetails.taskTypeDetails.visaType
                : this.taskTypeCode,
            jsonInput: this.subTaskDetails.jsonInput
              ? JSON.parse(this.subTaskDetails.jsonInput)
              : null,
            beneficiaryId: this.subTaskDetails.beneficiaryId
              ? this.subTaskDetails.beneficiaryId
              : null,
            relationshipCode: this.subTaskDetails.relationshipCode
              ? this.subTaskDetails.relationshipCode
              : null,
            taskTypeId: this.subTaskDetails.taskTypeId || null,
            taskTypeSaveJsonId: this.subTaskDetails.taskTypeSaveJsonId || null,
            filingType:this.subTaskDetails.filingType || null
          };
          this.subTaskLoaded$.next(true);
        }
      });
    
      console.log('Check Primary data', this.primaryData);
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    this.observableSubscription$?.unsubscribe();
  }

}
